import { AXIS_TYPE } from "constants/chart.constants";
import { EvaChart } from "constants/charts.enums";

import { ColumnGroup, DataEnum, IGroupByListColumn } from "models";

/**
 * Returns an array of objects filtered by a given data types
 */
const filterByType = (
  dataTypeList: string[],
  list: IGroupByListColumn[],
  chartType?: string,
  axisType?: string
): IGroupByListColumn[] => {
  if (!dataTypeList.length) return list;

  // Convert dataTypeList to lowercase for case-insensitive comparison
  const lowercaseDataTypeList = dataTypeList.map((type) => type.toLowerCase());

  // only numerical fields for cross plot, no Dates subgroup for y axis
  if (
    (chartType === EvaChart.CrossPlot || chartType === EvaChart.CrossPlotMidstream) &&
    (axisType === AXIS_TYPE.x || axisType === AXIS_TYPE.y)
  ) {
    const datesSubgroupToIgnore = [ColumnGroup.Dates, ColumnGroup.General];
    return axisType === AXIS_TYPE.x
      ? list.filter((column) => {
          return (
            lowercaseDataTypeList.includes(column.dataType.toLowerCase()) ||
            (column.group === ColumnGroup.Dates &&
              !datesSubgroupToIgnore.includes(column.subgroup as ColumnGroup))
          );
        })
      : list.filter((column) =>
          lowercaseDataTypeList.includes(column.dataType.toLowerCase())
        );
  }

  /**
   * Probably temporary code, we also want to include 'Year-Qtr', but those fields not compatiable
   * with 'time' type x-axes, given the values are represented as '2014-Q1', for example. We'll need to figure out
   * some value/label solution that's compatible with echarts to use the 'time' type. */
  if (chartType === EvaChart.TrendDate || chartType === EvaChart.TrendDateMidstream) {
    return list.filter((column) =>
      axisType === AXIS_TYPE.x
        ? column.dataType === DataEnum.Date ||
          // fields outside of Dates group can have the integer data type but are not date fields
          (column.dataType === DataEnum.Integer && column.group === ColumnGroup.Dates) ||
          column.defaultUnit === "Year-Month"
        : lowercaseDataTypeList.includes(column.dataType.toLowerCase()) ||
          column.defaultUnit === "Year-Month"
    );
  }

  return list.filter((column) =>
    lowercaseDataTypeList.includes(column.dataType.toLowerCase())
  );
};

export default filterByType;
